import qs from 'qs'
import { HTTP } from './helpers/http.js'

export default {
  getOrganizationStream(organizationId, query) {
    query.filters = { ...query.filters }
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'indices' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/revs`
    return HTTP.get(url, params)
  },

  getAccounts(organizationId, query) {
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'indices' })
      },
    }
    const url = `api/v1.1/stream/${organizationId}/accounts`
    return HTTP.get(url, params)
  },

  getExplore(organizationId, query) {
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'indices' })
      },
    }

    const url = `/api/v1.1/stream/${organizationId}/explore`
    return HTTP.get(url, params)
  },
}
